/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   isBoundsOutsideDelta
 */

import type { MaybeNullBoundsObj } from '@zcode/state-type'
import { isNumber } from '@zcode/utils'
import { MAX_LAT_DELTA, MAX_LNG_DELTA } from '../constants/utils'

export const isBoundsOutsideDelta = (
  bounds?: MaybeNullBoundsObj,
  maxLatDelta = MAX_LAT_DELTA,
  maxLngDelta = MAX_LNG_DELTA
) => {
  if (!bounds) {
    return false
  }
  if (
    !isNumber(bounds.maxLat) ||
    !isNumber(bounds.maxLng) ||
    !isNumber(bounds.minLat) ||
    !isNumber(bounds.minLng)
  ) {
    return false
  }

  return (
    Math.abs(bounds.maxLat - bounds.minLat) > maxLatDelta ||
    Math.abs(bounds.maxLng - bounds.minLng) > maxLngDelta
  )
}
